import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import {Validator} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Paginate from "vuejs-paginate";
import JsZip from 'jszip'
import JSZipUtils from 'jszip-utils'
import { saveAs } from 'file-saver';
import PageTracker from '../../../../common/PageTrackerHelper'
import { BasicSelect } from 'vue-search-select';
import moment from 'moment';
import { getCountfun } from '../../../../common/validations.js'
import keycloak from '../../../../common/Keycloak';

export default {
  name: 'ScanPODReport',
  components: {
      VueElementLoading,
      Paginate,
      JsZip,
      BasicSelect
  },
  mixins:[PageTracker],
  data: function() {
      return {
        fileTypeArray:['Delivery','WHHandover','DTOWHHandover'],
        shipmentTypeList : [],
        shipmentType : '',
        hubzone: '',
        hubname: '',
        hubZoneList:[],
        hubServiceCenterList:[],
        client:'',
        clientList:[],
        clientArrayList : [],
        ShippingID:'',
        ShippingIDArray:[],
        fileType:'',
        userID : '',
        users:[],
        dateobj : {
          startDate : '',
          endDate:''
        },
        netAmt:'',
        ScanPODList:[],
        changeStatus : '1',
        searchFlag:false,
        BatchArray:[],
        localuserid : '',
        localusermailid : '',
        rolename : '',
        NodetailsFlag:false,
        isEmail:false,
        pageno: 1,
        pagecount: 0,
        imgUrls:[],
        srLoader :'',
        userObj: {},
        loader:'<div class="velmld-spinner"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 24 30" xml:space="preserve"><rect x="0" y="5.59869" width="4" height="19.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="10" y="9.59869" width="4" height="11.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="20" y="12.4013" width="4" height="6.19739" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>',
        clientItemObj:{ value: "",text: ""},
        SearchLoading: false,
        ScanPODAssignBatchList: [],
        searchAssignBatch: false,
        assignBatchNo: '',
        userDataKey : '',
        userRolesFE : []
      }
  },
  created: function() {
  //this.changeDateFormat();
  },
  async mounted(){
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    this.getHubZoneData();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    console.log('userdetail',userdetail);

    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.rolename = userdetail.userrole[0]['rolename'];
    this.userRolesFE = userdetail.userroleFE;
    this.hubname = userdetail.hubdetails[0];
    this.localuseroutsourcingid = userdetail.outsourcingid;
    this.getHubzoneIDByHubID(this.hubname)
    //this.hubzone = '2'

    //this.getHubServiceCenterData();
    this.pageno= 1,
    this.getClientList();
    this.getshipmentTypes();
    this.getUserList();
    this.OutSourcingMasterId = userdetail.outsourcingid;

  },
  methods : {
    getclients(obj){
    this.clientItemObj = obj
    this.client = this.clientItemObj.value
  },
    getdeliveyList(obj) {
      this.userObj = obj;
      this.userID = obj.value;
    },
    getHubzoneIDByHubID(hubid){

      let payloadData = {"hubids": [parseInt(this.hubname)]}
      axios.post(apiUrl.api_url + 'external/hubservicecenter/hubarray/get/hubzoneid', payloadData)
       .then((response) => {
         let hubname = (this.hubname).toString()
         let res = response.data.data
           if(response.data.code===200){

               this.hubzone =response.data.data[hubname];
               this.getHubListByZone()
           }
           else {
               this.hubzone='';
           }
       })
       .catch((httpException) => {
           this.$alertify.error("hub data not found");
           console.error('exception is:::::::::', httpException)
       })
    },
    //to get client list
    getClientList() {
      axios.get(apiUrl.api_url + 'external/getclientlist', {})
        .then((response) => {
            if(response.data.code===200){
              this.clientArrayList=response.data.data;
              for (var i = 0; i < this.clientArrayList.length; i++) {
                this.clientList.push({
                  value: this.clientArrayList[i].ClientMasterID,
                  text: `${this.clientArrayList[i].CompanyName}`
                })
              }
            }
            else {
                this.clientList=[];
            }
        })
        .catch((httpException) => {
              this.$alertify.error("client data not found");
              console.error('exception is:::::::::', httpException)
        })
    },
    //to get Hub Zone list
    getHubZoneData() {
      axios.get(apiUrl.api_url + 'external/gethubzonelist', {})
        .then((response) => {
            if(response.data.code===200){
                this.hubZoneList=response.data.data;
            }
            else {
                this.hubZoneList=[];
            }
        })
        .catch((httpException) => {
              this.$alertify.error("hubzone data not found");
              console.error('exception is:::::::::', httpException)
        })
    },

    //to get Hub Service Center list
    getHubServiceCenterData() {
      this.users = []
      axios.get(apiUrl.api_url + 'external/gethublist', {})
        .then((response) => {
            if(response.data.code===200){
                this.hubServiceCenterList=response.data.data;
            }
            else {
                this.hubServiceCenterList=[];
            }
        })
        .catch((httpException) => {
              this.$alertify.error("Hub data not found");
              console.error('exception is:::::::::', httpException)
        })

    },
    getHubListByZone() {

      axios.get(apiUrl.api_url + `external/getzonewisehublist?zoneid=`+ parseInt(this.hubzone), {})
        .then((response) => {
            if(response.data.code === 200){
                this.hubServiceCenterList = response.data.data.sort(function(a, b){
                 var nameA=a.HubName.toLowerCase(), nameB=b.HubName.toLowerCase()
                 if (nameA < nameB) //sort string ascending
                  return -1
                 if (nameA > nameB)
                  return 1
                 return 0 //default return value (no sorting)
                });

            }
            else {
                this.hubServiceCenterList=[];
            }
        })
        .catch((httpException) => {
              //this.$alertify.error("Hub data not found");
              console.error('exception is:::::::::', httpException)
        })
    },

    async emailPOD(){
      this.$validator.validateAll().then(result => {

        if(result) {
          let serchData = {};
          this.SearchLoading = true
          if(this.changeStatus == '1'){
            //let [ HubzoneID,Hubzone] = this.hubzone.split('@');
            //let [HubID, Hub] = this.hubname.split('@');
            let shipmentTypeObj = this.shipmentTypeList.find(shiptype => shiptype.businessconfig == this.shipmentType);
            serchData = {
              "HubId":this.hubname,
              "ClientID":(this.client).toString(),
              "ShipmentType": shipmentTypeObj.shipType,
              "FileType": this.fileType,
              "localuserid":this.localuserid,
              "localusermailid": this.localusermailid//"sonal.langade@xpressbees.com"
             }

            if(this.userID){
              serchData.DeliveryUserID = this.userID
            }
            if(this.dateobj.startDate){
              serchData.StartDate = this.dateobj.startDate
            }
            if(this.dateobj.endDate){
              serchData.EndDate = this.dateobj.endDate
            }
            if(this.dateobj.endDate){
              serchData.EndDate = this.dateobj.endDate
            }
            if(this.netAmt){
              serchData.NetAmount = this.netAmt
            }

          } else {
            let str = this.ShippingID.replace(/ /g, "").trim()//.replace(/(^,)|(,$)/g, "").trim()
            this.ShippingIDArray = str.split(",").map(String);
            serchData = {
               "Shipments":this.ShippingIDArray,
               "localuserid":this.localuserid,
               "localusermailid":this.localusermailid//"sonal.langade@xpressbees.com,Priyanka.Ghule@xpressbees.com"
             }
          }

          axios({
              method: 'POST',
              'url': apiUrl.api_url + 'ScanPODReport/emailPOD',
              //'url':' https://lastmileallocationpod-apistage.xbees.in/expose/web/get/assignedbatchno',
              'data': serchData
          })
           .then((response) => {
               if(response.data.code===200){
                   this.$alertify.success("Email Send Successfully");
               }
               else {
                 this.$alertify.error("Error while sending Email ..");
               }
               this.SearchLoading = false
           })
           .catch((httpException) => {
               this.$alertify.error("Error while sending Email .!");
               console.error('exception is:::::::::', httpException)
           })
      }
    })

    },

    getPaginationData(pageNum) {
      this.pageno = (pageNum -1)*10;
      this.getScanPODReport();
    },
    searchdata(){
      this.pageno = 0;
      this.$refs.paginate.selected= 0;
      this.getScanPODReport();
    },
    searchAssignBatchDetails(batchID) {
      return new Promise((resolve,reject) =>{
        let searchData = {
          "AssignBatchNo": batchID
        }
        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'get/scanPOD/details/byAssignBatchNo',
            'data': searchData
        })
        .then(async result => {
          this.ScanPODAssignBatchList = result.data.data;
          resolve(true);
          //console.log('result',result);
        })
      })
    },

    getScanPODReport(){
      this.$validator.validateAll().then(async result => {
        if(result) {
          let serchData = {};
          this.SearchLoading = true
          if(this.changeStatus == '2'){
            await this.searchAssignBatchDetails(this.assignBatchNo);
            this.SearchLoading = false;
            this.searchAssignBatch = true;
            return true;

          }else if(this.changeStatus == '1'){
            //let [ HubzoneID,Hubzone] = this.hubzone.split('@');
            //let [HubID, Hub] = this.hubname.split('@');
            let shipmentTypeObj = this.shipmentTypeList.find(shiptype => shiptype.businessconfig == this.shipmentType);

            serchData = {
              "HubId":this.hubname,
              "ClientID":(this.client).toString(),
              "ShipmentType":shipmentTypeObj.shipType,
              "FileType": this.fileType,
              "pageNo" : this.pageno,
              "pageSize" : 10
             }

            if(this.userID){
              serchData.DeliveryUserID = this.userID
            }
            if(this.dateobj.startDate){
              serchData.StartDate = this.dateobj.startDate
            }
            if(this.dateobj.endDate){
              serchData.EndDate = this.dateobj.endDate
            }
            if(this.dateobj.endDate){
              serchData.EndDate = this.dateobj.endDate
            }
            if(this.netAmt){
              serchData.NetAmount = this.netAmt
            }

          } else {
            this.ShippingIDArray =[]
            let str = this.ShippingID.replace(/ /g, "").trim()//replace(/(^,)|(,$)/g, "")
            this.ShippingIDArray = str.split(",").map(String);

            serchData = {
               "Shipments":this.ShippingIDArray,
               "pageNo" : this.pageno,
               "pageSize" : 10
             }
          }

          //console.log('serchData',serchData);
          this.ScanPODList = []
          axios({
              method: 'POST',
              'url': apiUrl.api_url + 'ScanPODReport/list',
              'data': serchData
          })
          .then(async result => {

            if(result.data.code == 200){
               this.searchFlag = true
               this.ScanPODList = result.data.data
               let totalRows = result.data.totalCount;
               this.imgUrls =[]
               result.data.data.map(img => {
                 if(img.PODPath)
                 this.imgUrls.push(img.PODPath)
               })

               if (totalRows < 10) {
                   this.pagecount = 1;
               } else {
                   this.pagecount = Math.ceil(totalRows / 10)
               }

            }else{
                this.searchFlag = true
                this.NodetailsFlag = true
                this.ScanPODList = []
            }
            this.SearchLoading = false
          })
      }
    })
    },
    getHubList(){
       axios.get(apiUrl.api_url + 'shipmentMisrout/gethublist', {})
        .then((response) => {
            if(response.data.code===200){
                this.hubServiceCenterList =response.data.data;
            }
            else {
                this.hubServiceCenterList=[];
            }
        })
        .catch((httpException) => {
            this.$alertify.error("hub data not found");
            console.error('exception is:::::::::', httpException)
        })
    },
    getUserList(){
      this.users = []
      if (this.rolename.toLowerCase()=="agent" || this.userRolesFE.includes("agent")){
        let Emppayload = {
          "OutSourcingId": this.localuseroutsourcingid,
          "hubid": [this.hubname]
        }
        let apiendpoint = 'agenthandovershipments/getDeliveryUserName';
        if (keycloak.enableKavach) {
          apiendpoint = 'user/migration/getoutsourceuserlist';
        }
        axios.post(apiUrl.api_url + apiendpoint, {
            Emppayload
          })
          .then((response) => {

          if (response.data.code === 200) {
              this.DeliverySRList = response.data.data;
              $.each(response.data.data , (key,obj)=>{
                this.users.push({
                  value: `${obj.DeliveryUserId}`,
                  text: `${obj.FirstName} ${obj.LastName} (${obj.OldDeliveryUserOrUserId} - ${obj.DeliveryUserId}) - (${obj.MobileNumber})`
                })
              });
              if (!this.users.length){
                   this.$alertify.error("Delivery user not found");
              }
           }
            else {
              this.users = [];
                // this.$alertify.error("Delivery user not found");
            }
            this.srLoader='';
          })
          .catch(httpException => {
            this.$alertify.error("User details not found");
            console.error("exception is:::::::::", httpException);
          });
      }else {
       let payloadData = {"HubID":[this.hubname]}
       this.srLoader = this.loader;
       let apiendpoint = 'external/getremoteuserdetails/byhubid';
       if (keycloak.enableKavach) {
        apiendpoint = 'user/migration/getuserdetailsbyhubids';
       }
       axios.post(apiUrl.api_url + apiendpoint, payloadData)
        .then(async (response) => {
            if(response.data.code===200){
                //this.users = response.data.data.results;
                await response.data.data.results.map(userdata=>{
                  if (userdata.username != null){
                      //this.getDeliveryUname.push(userdata);
                      this.users.push({value:userdata.userid, text: `${userdata.FirstName} ${userdata.LastName} (${userdata.OldDeliveryUserOrUserId}) (${userdata.userid})`})
                  }
                })
            }
            else {
                this.users=[];
            }
            this.srLoader = '';
        })
        .catch((httpException) => {
            this.$alertify.error("hub data not found");
            console.error('exception is:::::::::', httpException)
        })
      }
    },

    getshipmentTypes(){
       axios.post(apiUrl.api_url + 'external/businessconfig/get/list',{})
        .then((response) => {
            if(response.data.code===200){
                this.shipmentTypeList =response.data.data.data;
            }
            else {
                this.hubServiceCenterList=[];
            }
        })
        .catch((httpException) => {
            this.$alertify.error("Shipment type data not found");
            console.error('exception is:::::::::', httpException)
        })
    },
   setFileType(e){
     let selectedShipType = $("#shipmentType option:selected").text();
     this.fileTypeArray = [];
     this.fileType = '';
     if(selectedShipType == 'eComm-Reverse-PickUp'){
       this.fileTypeArray.push('DTOWHHandover');
     } else {
       this.fileTypeArray.push('Delivery','WHHandover');
     }

     //console.log('shipmentType',this.shipmentType);
   },
   getImage(PODPath){
     if(PODPath){
       window.open(PODPath);
     }else{
        this.$alertify.error("No image Available");
     }
   },
    clearAll(){
      this.searchAssignBatch = false;
      this.searchFlag = false;
      this.ScanPODAssignBatchList = [];
      this.assignBatchNo = ''
      this.ScanPODList = []
      this.imgUrls =[]
      this.ShippingIDArray =[]
      this.pageno= 1,
      this.pagecount= 0,
      this.$validator.reset();
      this.errors.clear();
      this.searchFlag = false
      this.NodetailsFlag = false
      this.dateobj = {
        startDate : '',
        endDate:''
      },
      this.shipmentType = ''
      this.fileType =''
      this.userID =''
      this.client=''
      this.ShippingID=''
      this.ShippingIDArray=[]
      this.userID = ''
      this.userObj= {},
      this.client=''
      this.clientItemObj= { value: "",text: ""}
      this.netAmt = ''
    },
  },
  filters: {
      moment: function(date) {
        if (date == null || date == '')
          return '--'
        return moment(date).format('DD-MM-YYYY HH:mm:ss');
      }
  }
}

Validator.extend('VerifyShippingid', {
  getMessage: field => "maximum 100 Shipping ids you can enter",
  validate: async value => {
      var shippingids = $("#ShippingID").val();
      let cnt = await getCountfun(shippingids);
      return cnt;
  }
});
Validator.extend('max_shipments', {
  getMessage: field => "maximum 50 Shipments you can enter",
  validate: value => {
      var shippingIDs = $("#ShippingID").val();
      let shipment=shippingIDs.split(/[,]+/);
      if(shipment.length>50){
        return false;
      }else{
        return true;
      }
  }
});



// WEBPACK FOOTER //
// ./src/views/components/ScanPODSheet/ScanPODReport/ScanPODReport.component.js